<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>眼运动</el-breadcrumb-item>
      <el-breadcrumb-item>年费订单</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.orderid" @keyup.enter.native="clicksearch" placeholder="请输入订单号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-select v-model="keywords.orderstatus" placeholder="请选择" class="select"  style="width: 200px;">
              <el-option label="请选择订单状态" value="-1"></el-option>
              <el-option label="待支付" value="0"></el-option>
              <el-option label="已支付" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Orderid" label="订单号" min-width="6%"></el-table-column>
          <el-table-column prop="Remark" label="解锁度数" min-width="6%"></el-table-column>
          <el-table-column prop="Glassusername" label="手机号码" min-width="6%"></el-table-column>
          <el-table-column prop="Amount" label="合计金额" min-width="6%"></el-table-column>
          <el-table-column prop="OrderstatusName" label="订单状态" min-width="4%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" min-width="6%"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
            :current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyMiniProgramYanYunDongOrderUnlockDegree',
  data () {
    return {
      activeName: 'first',
      ProductNameOptions: [],
      SpecificationsOptions: [],
      // 查询
      keywords: {
        orderid: '',
        orderstatus: '-1'
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1
    }
  },
  mounted () {
    this.apiYanYunDongOrderUnlockDegreeGetNum()
    this.apiYanYunDongOrderUnlockDegreeGetList()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    selectchange(ptype){
    },
    clickmodify (row) {
      this.activeName = 'three'
   },
    clickreturn () {
      this.activeName = 'first'
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiYanYunDongOrderUnlockDegreeGetNum()
      this.apiYanYunDongOrderUnlockDegreeGetList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiYanYunDongOrderUnlockDegreeGetList()
    },
    apiYanYunDongOrderUnlockDegreeGetNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_YanYunDongOrderUnlockDegreeGetNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiYanYunDongOrderUnlockDegreeGetList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        orderid: that.keywords.orderid,
        orderstatus: that.keywords.orderstatus
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_YanYunDongOrderUnlockDegreeGetList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
